module.exports = __webpack_public_path__ + "static/media/data_lake_storage.6647961e.svg";